export default {
    showSuccess(ctx, text) {
        ctx.$notify({
            title: 'Success',
            message: text,
            type: 'success'
        })
    },
    showError(ctx, text) {
        ctx.$notify({
            title: 'Error',
            message: text,
            type: 'error'
        })
    }
}
